import { Component, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import {
    Client, Organisme, Service,
    ServicesService, Utilisateur, UtilService as UtilisateurService
} from '@estel-numerique/galaclick-api';
// Utilisation de la fenetre de Ajout/Modif du module utilisateur
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseListeComponent } from '@classes/extends';
import { AgentAdv, ServiceAdv, ServiceAnaSupAdv, ServicePeseeAdv, TypeHeadElement } from '@classes/models';
import { SelectFiltre, SelectGala } from '@composants/index';
import { FiltreHelper, FiltresService, TypeFiltre } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { SelectGala as SelectGala_1, SelectFiltre as SelectFiltre_1 } from '../composants/select/select.component';
import { NgClass } from '@angular/common';
import { CpIconSort } from '../composants/icons/icons.component';
import { FormsModule } from '@angular/forms';
import { PaginationV2Component } from '../composants/paginationV2/paginationV2.component';
import { MatButton } from '@angular/material/button';

/**
  * PorteFeuille Client de l'agent
  */
@Component({
    templateUrl: './pfClientMoveMulti.component.html',
    styleUrls: ['./pfClientMoveMulti.component.scss'],
    imports: [DialogGalaComponent, SelectGala_1, MatCheckbox, NgClass, CpIconSort, FormsModule, SelectFiltre_1, PaginationV2Component, MatButton]
})
export class PFClientMoveMultiComponent extends BaseListeComponent implements OnInit {
    private wsServ = inject(ServicesService);
    private filtresService = inject(FiltresService);
    private wsUtil = inject(UtilisateurService);
    private dialogRef = inject<MatDialogRef<PFClientMoveMultiComponent>>(MatDialogRef);

    public titre: string;
    public codeModule: string = Constantes.CodeOption.OFICHIERUSER;
    // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    public nomPage = "PFCLIENT";

    private selectedValue = 0; // Nb de lignes selectionnées
    private utilTitulaire: Utilisateur;
    private utilBeneficiaire: Utilisateur;

    protected isFiltreHidden = true;

    @ViewChild('selectClient') public selectClient: SelectFiltre;
    @ViewChild('selectAgent') public selectAgent: SelectFiltre;

    @ViewChild('agentTitulaire') public agentTitulaire: SelectGala;
    @ViewChild('agentBeneficiaire') public agentBeneficiaire: SelectGala;

    @Output() fClientMoveMulti = new EventEmitter();

    // Entete de tableau
    protected headElements: TypeHeadElement[] = [];

    // Traduction
    protected lgTrad: Record<string, string> = {};
    protected lgTradFiltre: Record<string, string> = {};

    // Filtre
    protected filtreOrganisme: TypeFiltre<number>[] = [];
    protected filtreService: TypeFiltre<string>[] = [];
    protected filtreClient: TypeFiltre<number>[] = [];
    protected filtreTypeReferent: TypeFiltre<string>[] = [];

    // Liste et formulaire agent
    protected listeTitulaire: AgentAdv[] = [];
    protected listeBeneficiaire: AgentAdv[] = [];
    private listeAgent: AgentAdv[] = [];
    // private formAgent: UntypedFormGroup;

    // Action disponible a la ligne
    protected selectAction: { id: number, label: string }[] = [];
    protected agentBeneficiaireSelected: Utilisateur = null;
    protected agentTitulaireSelected: Utilisateur = null;

    // Permet de savoir si l'agent sélectionné est habilité pour un export
    protected boHabilitation = false;
    protected aucuneDonnees = false;

    public listeOrga: Organisme[] = [];
    get listeElementsAff() {
        return this.getListeAffichee<ServicePeseeAdv | ServiceAnaSupAdv>();
    }
    constructor() {
        super();
        this.dialogRef.updateSize('1500px');
        // Traduction entête de colonne
        this.headElements = [
            { libelle: " ", tri: 'SELECTED', sortable: true },
            {
                libelle: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.CODE") + " ",
                tri: 'NUCHEP', sortable: true
            },
            {
                libelle: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.NOM") + " ",
                tri: 'CLIENT.NOM', sortable: true
            },
            {
                libelle: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.SERVICE") + " ",
                tri: 'SERVICE', sortable: true
            },
            {
                libelle: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.INTERLOCUTEUR") + " ",
                tri: 'INTERLOCUTEUR', sortable: true
            },
            {
                libelle: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.ORGAREF") + " ",
                tri: 'ORGANISME.COSIG', sortable: true
            },
            {
                libelle: this.translate.instant("APPPORTEFEUILLECLIENT.COLTAB.TYPEREFERENT") + " ",
                tri: '', sortable: false
            }];
        // Traduction dans la page
        this.lgTrad = {
            ACTION: this.translate.instant("ACTION"),
            DEBUT: this.translate.instant("DEBUT"),
            PRECEDENT: this.translate.instant("PRECEDENT"),
            SUIVANT: this.translate.instant("SUIVANT"),
            FIN: this.translate.instant("FIN"),
            ENR: this.translate.instant("ENR"),
            RET: this.translate.instant("RET"),
            VAL: this.translate.instant("VAL"),
            AGENTBENEF: this.translate.instant("APPPORTEFEUILLECLIENT.MODALMOVEMULTI.AGENTBENEF"),
            AGENTTITU: this.translate.instant("APPPORTEFEUILLECLIENT.MODALMOVEMULTI.AGENTTITU"),
            NOAGENTSELECTED: this.translate.instant("APPPORTEFEUILLECLIENT.MODALMOVEMULTI.ERREUR.NOAGENTSELECTED"),
            NOSELECTED: this.translate.instant("APPPORTEFEUILLECLIENT.MODALMOVEMULTI.ERREUR.NOSELECTED"),
            MSGNODATAS: this.translate.instant("APPPORTEFEUILLECLIENT.MODALMOVEMULTI.MSGNODATAS")
        };
        // traduction des filtres
        this.lgTradFiltre = {
            FILTRE: this.translate.instant("FILTER"),
            ACTIF: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.ACTIF"),
            ORGANISME: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.ORGANISME"),
            SERVICE: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.SERVICE"),
            CLIENT: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.CLIENT"),
            AGENT: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.AGENT"),
            SELECTED: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.SELECTED"),
            TYPEREFERENT: this.translate.instant("APPPORTEFEUILLECLIENT.FILTRE.TYPEREFERENT")
        };
    }

    ngOnInit() {
        super.ngOnInit();
        this.init().catch(e => this.util.fErreur(e));
    }

    public checkCreer() {
        return false;
    }

    private async init() {
        if (this.droitsAccess.write) {
            this.util.showLoader();
            try {
                this.titre = this.translate.instant("APPPORTEFEUILLECLIENT.MODALMOVEMULTI.TITRE_EXPORT");
                try {
                    const listAgentTmp: AgentAdv[] = await lastValueFrom(this.wsUtil.getUtilisateursAgent());
                    listAgentTmp.forEach(ag => {
                        ag.NOMPRENOM = ag.NOM + " " + ag.PRENOM;
                    });
                    this.listeAgent = Object.assign([], listAgentTmp);
                    this.listeTitulaire = Object.assign([], listAgentTmp);
                    this.listeBeneficiaire = Object.assign([], listAgentTmp);
                } catch (e) {
                    this.util.fErreur(e);
                }
                this.showHideFiltres(false);
                // Récupération du portefeuille client
                await this.chargeListe();
            } catch (e) {
                this.util.fErreur(e);
            } finally {
                this.util.hideLoader();
            }
        } else {
            this.util.fErreur(this.translate.instant("ACCESFONCTIONINTERDIT"));
        }
    }

    private async chargeListe() {
        //on charge les organismes en dehors du if car necessaire lors du appliquefiltre()
        this.filtreOrganisme = await this.filtresService.getFiltreOrga();
        this.filtreTypeReferent = this.filtresService.getFiltreTypeReferent(false);

        if (this.getBackupPageParam(this.nomPage, false)) {
            this.filtreService = this.filtresService.restoreFiltreService(this.nomPage);
        } else {
            // filtre Service
            this.filtreService = await this.filtresService.getFiltreRFService();
        }
    }

    public hideModal() {
        this.agentTitulaireSelected = null;
        this.agentBeneficiaireSelected = null;
        this.dialogRef.close();
    }

    public async selectAgentTitulaire(agent: Utilisateur) {
        this.agentTitulaireSelected = agent;
        if (agent != null) {
            this.listeBeneficiaire = this.listeAgent.filter(util => agent.USRID != util.USRID);
        } else {
            this.listeBeneficiaire = this.listeAgent;
        }
        this.listeBeneficiaire = [...this.listeBeneficiaire];
        await this.validerAgents();
    }

    public async selectAgentBeneficiaire(agent: Utilisateur) {
        this.agentBeneficiaireSelected = agent;
        if (agent != null) {
            this.listeTitulaire = this.listeAgent.filter(util => agent.USRID != util.USRID);
        } else {
            this.listeTitulaire = this.listeAgent;
        }
        this.listeTitulaire = [...this.listeTitulaire];
        await this.validerAgents();
    }
    protected reinitEtat() {
        this.boHabilitation = false;
        this.aucuneDonnees = true;
    }
    protected clearBeneficiaire() {
        this.reinitEtat();
    }
    protected clearTitulaire() {
        this.reinitEtat();
    }
    private async validerAgents() {
        this.util.showLoader();
        try {
            if (this.agentTitulaire.selectedItem == null || this.agentBeneficiaire.selectedItem == null) {
                this.util.showToastError(this.lgTrad.NOAGENTSELECTED);
            } else {
                await this.initListElement();
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public async initListElement() {
        let listContrat: (ServicePeseeAdv | ServiceAnaSupAdv)[] = [];

        this.selectClient?.resetOptions();
        this.utilTitulaire = this.agentTitulaire.selectedItem as Utilisateur;
        this.utilBeneficiaire = this.agentBeneficiaire.selectedItem as Utilisateur;
        listContrat = await lastValueFrom(
            this.wsServ.getServiceActifAgentAtDate(this.utilTitulaire.USRID, null, true));

        if (listContrat.length >= 0) {
            const listeClients: Client[] = [];
            listContrat.forEach((servAdv) => {
                servAdv.SELECTED = false;
                servAdv.INTERLOCUTEUR = `${servAdv?.CONTACT?.NOM ?? ''} ${servAdv?.CONTACT?.PRENOM ?? ''}`;
                servAdv.ACTIVITE = this.util.date.compareTodayDate(servAdv.DDEBUT, servAdv.DFIN);

                if (servAdv?.CLIENT?.REFERENT?.USRID == null || servAdv?.CLIENT?.REFERENT?.USRID == 0) {
                    servAdv.SERVICE = this.translate.instant('TYPESERVICE.' + servAdv.TYPESERVICE.CODESERV);
                } else {
                    servAdv.SERVICE = '';
                }
                servAdv.AGENTCOMPLET = (servAdv.AGENT) ? servAdv.AGENT.NOM + " " + servAdv.AGENT.PRENOM : "";
                // INITIALISATION DES FILTRES EN FONCTION DES ENREGISTREMENTS
                listeClients.push(servAdv.CLIENT);
                // Pour l'import on affiche la liste des agents
            });

            this.filtreClient = this.filtresService.getFiltreClientsFromListe(listeClients, this.filtreClient);

            // Si on a des éléments, on indique qu'on veut trier par NUCHEP
            this.sortBy("NUCHEP");
        }
        this.fSetListeElements(listContrat);
    }

    //Affiche ou cache les filtres selon l'état de base
    public showHideFiltres(hide?: boolean) {
        if (hide != null) {
            this.isFiltreHidden = hide;
        } else {
            this.isFiltreHidden = !this.isFiltreHidden;
        }
    }

    protected filtrage() {
        // On filtre, ça reset le selected
        let listeTemp = this.getListeElements<ServiceAdv>();
        let boOK = false;
        if (listeTemp.length > 0) {
            this.aucuneDonnees = false;
            if (this.agentBeneficiaireSelected != null) {
                let boOrga = null;
                listeTemp = listeTemp.filter((serv: ServiceAdv) => {
                    boOrga = false;
                    if (serv.CLIENT.REFERENT.USRID > 0) {
                        boOrga = true;
                    }
                    //verifie que le service est du meme orga que l'utilisateur
                    this.agentBeneficiaireSelected.LISTESIG.forEach((sig) => {
                        if (sig.IDORGA == serv.ORGANISME.IDORGA) {
                            boOrga = true;
                        }
                    });
                    if (!boOrga) {
                        serv.SELECTED = false;
                    }
                    return boOrga;
                });
                this.boHabilitation = (listeTemp.length > 0) ? true : false;
            } else {
                this.boHabilitation = false;
            }
        } else {
            this.aucuneDonnees = true;
        }

        // filtre par organisme
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreOrganisme)) {
            listeTemp = listeTemp.filter((data: ServiceAnaSupAdv | ServicePeseeAdv) => {
                boOK = false;
                this.filtreOrganisme.forEach((f) => {
                    if (f.filtre == true && data.CLIENT.REFERENT.USRID == 0) {
                        //verif qu'il n'y ai pas un organisme de type regroupement
                        const orga = this.listeOrga.find((o: Organisme) => { return o.IDORGA == f.value; });
                        if (orga?.FILS != null && orga.FILS.length > 0) {
                            //c'est un regroupement on prend en compte ses enfants
                            orga.FILS.forEach((org: number) => {
                                if (data.ORGANISME.IDORGA == org) {
                                    boOK = true;
                                }
                            });
                        } else {
                            if (data.ORGANISME.IDORGA == f.value) {
                                boOK = true;
                            }
                        }
                    }
                });
                return boOK;
            });
        }

        // filtre par service
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreService)) {
            listeTemp = listeTemp.filter((data: ServiceAnaSupAdv | ServicePeseeAdv) => {
                return this.filtreService.find((f) =>
                    f.filtre == true &&
                    (FiltreHelper.isFiltrageAucunEtValide(f, data) ||
                        // On ne veut pas filtrer les clients référents si on est en export
                        (data?.CLIENT.REFERENT.USRID == 0 && data.TYPESERVICE.CODESERV === f.value))
                );
            });
        }

        // filtre par client
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreClient)) {
            listeTemp = listeTemp.filter((data: ServiceAnaSupAdv | ServicePeseeAdv) => {
                return this.filtreClient.find((f) => {
                    return (f.filtre == true && data.CLIENT.IDCLIENT === f.value);
                });
            });
        }

        // filtre par agent
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreTypeReferent)) {
            listeTemp = listeTemp.filter((s: ServiceAdv) => {
                boOK = false;
                this.filtreTypeReferent.forEach((f) => {
                    if (f.filtre == true) {
                        if (f.value == "RC" && s.CLIENT?.REFERENT?.USRID == this.utilTitulaire?.USRID) {
                            boOK = true;
                        } else if (f.value == "RSP" && s.AGENT?.USRID == this.utilTitulaire?.USRID &&
                            s.CLIENT?.REFERENT?.USRID == 0) {
                            boOK = true;
                        } else if (f.value == "RSS") {
                            boOK = false;
                        }
                    }
                });
                return boOK;
            });
        }

        // Recalcule le nombre d'éléments selectionnés en fonction du filtre
        // (l'enregistrement final est basé sur la liste filtree)
        this.selectedValue = 0;
        listeTemp.forEach(lef => {
            if (lef.SELECTED) this.selectedValue++;
        });
        this.filtresService.backupFiltreOrga(this.filtreOrganisme);
        return listeTemp;
    }

    public checkContrat(service: ServicePeseeAdv | ServiceAnaSupAdv) {
        this.selectedValue = (service.SELECTED) ? this.selectedValue + 1 : this.selectedValue - 1;
    }

    public async onMoveClient() {
        try {
            this.util.showLoader();
            if (this.droitsAccess.write) {
                let newIdAgent: number;

                if (this.utilBeneficiaire == null || this.utilTitulaire == null) {
                    this.util.showToastError(this.lgTrad.NOAGENTSELECTED);
                } else {
                    newIdAgent = this.utilBeneficiaire.USRID;
                }

                const listService: (ServicePeseeAdv | ServiceAnaSupAdv)[] = [];

                this.getListeFiltree<ServicePeseeAdv | ServiceAnaSupAdv>()
                    .forEach((lef: ServicePeseeAdv | ServiceAnaSupAdv) => {
                        if (lef.SELECTED) {
                            const serv: Service = {
                                IDSERVICE: lef.IDSERVICE,
                                CLIENT: lef.CLIENT,
                                DISCRIMINATOR: lef.DISCRIMINATOR
                            };
                            listService.push(serv);
                        }
                    });

                if (listService.length == 0) {
                    this.util.showToastError(this.lgTrad.NOSELECTED);
                }

                if (newIdAgent > 0 && listService.length > 0) {
                    // Déplacement des service vers newIdAgent
                    await lastValueFrom(this.wsServ.putMoveServiceAgent(newIdAgent, listService));

                    this.fClientMoveMulti.emit();
                    this.hideModal();
                }
            }
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public changeAll($event: MatCheckboxChange) {
        this.getListeFiltree<ServicePeseeAdv | ServiceAnaSupAdv>().forEach(e => {
            //Si le type référent est principal ou référent, on sélectionne
            if (this.getTypeReferent(e) !== '') {
                e.SELECTED = $event.checked;
            }
        });
    }

    public getTypeReferent(serv: ServicePeseeAdv | ServiceAnaSupAdv) {
        // TODO: Ajouter enum
        let typeReferent = "";
        if (serv?.AGENT?.USRID == this.utilTitulaire?.USRID) {
            typeReferent = this.translate.instant('APPPORTEFEUILLECLIENT.MODALMOVEMULTI.RSP');
        }
        if (serv?.CLIENT?.REFERENT?.USRID == this.utilTitulaire.USRID) {
            typeReferent = this.translate.instant('APPPORTEFEUILLECLIENT.MODALMOVEMULTI.RC');
        }
        return typeReferent;
    }

    public verificationAffService(serv: ServicePeseeAdv | ServiceAnaSupAdv) {
        // Si c'est un référent client, on affiche pas le service
        let service = "";
        if (serv.CLIENT.REFERENT.USRID == null || serv.CLIENT.REFERENT.USRID == 0) {
            service = serv.SERVICE;
        }
        return service;
    }

    public getOrgaCode(serv: ServicePeseeAdv | ServiceAnaSupAdv) {
        // Si c'est un référent client, on affiche pas l'organisme
        let cosig = "";
        if (serv?.CLIENT?.REFERENT?.USRID == 0) {
            cosig = serv?.ORGANISME?.COSIG;
        }
        return cosig;
    }
}
